import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-login" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "staging-text"
}
const _hoisted_4 = { class: "sso-area" }
const _hoisted_5 = { class: "sso-error" }
const _hoisted_6 = {
  key: 1,
  class: "sso-loading"
}

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { getEnvironmentConfig } from '@/utils/environment'
import IconEableM from '@/assets/images/logo-eaglem.svg';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const SSO_ERROR_MESSAGE: Record<string, string> = {
  no_code: '인증 코드를 받지 못했습니다.',
  token: '토큰 발급에 실패했습니다.',
  userinfo: '사용자 정보를 불러오지 못했습니다.',
  domain: '허용되지 않은 계정입니다. (4grit.com 계정만 로그인할 수 있습니다.)'
}

const envConfig = computed(() => getEnvironmentConfig());
const route = useRoute()

const ssoErrorMessage = computed(() => {
  const ssoError = route.query.ssoError
  if (!ssoError) return ''
  return SSO_ERROR_MESSAGE[ssoError as string] || 'NAVER WORKS 로그인에 실패했습니다.'
})

const handleWorksLogin = () => {
  const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://staging-eagle-api.beusable.net'
  window.location.href = `${baseUrl}/admin/user/sso?from=eaglem`
}

// SSO 인증 실패로 돌아온 경우엔 자동 리다이렉트하지 않고 에러를 표시(루프 방지)
if (!route.query.ssoError) {
  handleWorksLogin()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "login-card" }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _unref(IconEableM),
          alt: "이글M",
          class: "logo"
        }, null, 8, _hoisted_2),
        (envConfig.value.isStaging)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Staging"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (ssoErrorMessage.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(ssoErrorMessage.value), 1),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: handleWorksLogin
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" 다시 로그인 ")
                  ])),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, " NAVER WORKS 로그인으로 이동 중... "))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})